/**
 * Map full admin student form → staging decide API body pieces.
 */

export function buildDecideOverridesFromAdminForm(form) {
  const f = form || {};
  return {
    email: f.email || undefined,
    firstName: f.firstName || undefined,
    lastName: f.lastName || undefined,
    phoneNumber: f.mobile || f.phoneNumber || undefined,
    gender: f.gender || undefined,
    employeeId: f.employeeId || f.veStudentId || undefined,
    veStudentId: f.veStudentId || undefined,
    currentAddress: f.address || f.currentAddress || undefined,
    permanentAddress: f.permanentAddress || undefined,
    currentLocation: f.currentCity || f.currentLocation || undefined,
    pincode: f.pincode || undefined,
    parentsName: f.parentsName || undefined,
    parentsPhone: f.parentsPhone || undefined,
    parentsEmail: f.parentsEmail || undefined,
    linkedIn: f.linkedIn || undefined,
    dob: f.dob || undefined,
    experienceYears: f.experienceYears || undefined,
    availability: f.availability || undefined,
    profilePreference: f.profilePreference || undefined,
    diplomaDone: f.diplomaDone || undefined,
    bio: f.bio || undefined,
    notes: f.notes || undefined,
    motivation: f.motivation || undefined,
    resumeUrl: f.resumeUrl || undefined,
    domainId: f.domainId || undefined,
    countryId: f.country || undefined,
    stateId: f.state || undefined,
    cityId: f.cityId || undefined,
    batchId: f.batchId != null ? String(f.batchId).trim() : '',
    courseId: f.courseId || undefined,
    batchStartDate: f.batchStartDate || undefined,
    courseCompletionDate: f.courseCompletionDate || undefined,
    attendancePercentage: f.attendancePercentage || undefined,
    batchStatus: f.studentStatus || f.batchStatus || undefined,
    placementStatus: f.placementStatus || undefined,
    remarks: f.remarks || undefined,
    // Academics (applied via academicPatch on backend)
    degree: f.degree || undefined,
    university: f.university || f.btechInstitute || undefined,
    btechInstitute: f.btechInstitute || f.university || undefined,
    yearOfPassing: f.yearOfPassing || f.btechYear || undefined,
    percentage: f.percentage || f.btechMarks || undefined,
    percentageType: f.percentageType || f.btechMarksType || undefined,
    tenthMarks: f.tenthMarks || undefined,
    tenthMarksType: f.tenthMarksType || undefined,
    tenthYear: f.tenthYear || undefined,
    twelfthMarks: f.twelfthMarks || undefined,
    twelfthMarksType: f.twelfthMarksType || undefined,
    twelfthYear: f.twelfthYear || undefined,
    btechMarks: f.btechMarks || f.percentage || undefined,
    btechMarksType: f.btechMarksType || f.percentageType || undefined,
    btechYear: f.btechYear || f.yearOfPassing || undefined,
    mtechYear: f.mtechYear || undefined,
    mtechMarks: f.mtechMarks || undefined,
    mtechMarksType: f.mtechMarksType || undefined,
    mtechInstitute: f.mtechInstitute || undefined,
    phdDone: f.phdDone || undefined,
    phdYear: f.phdYear || undefined,
    whatsapp: f.whatsapp || undefined,
  };
}

export function resolveEnrollmentDecisionFromAdminForm(form, preferred = 'create') {
  const batchId = String(form?.batchId || '').trim();
  if (!batchId) return 'skip';
  return preferred === 'update' ? 'update' : 'create';
}

export function validateAdminFormForStaging(form) {
  const email = String(form?.email || '').trim();
  if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    return 'Enter a valid email before saving';
  }
  if (!String(form?.firstName || '').trim() || !String(form?.lastName || '').trim()) {
    return 'First name and last name are required';
  }
  if (!String(form?.mobile || form?.phoneNumber || '').trim()) {
    return 'Phone / mobile is required';
  }
  return null;
}
